<template>
  <GeneralForm :jenisJurnal="9" :title="title" :routeBack="routeBack" :jurnalUrl="url" />
</template>

<script>
import GeneralForm from '@/views/jurnal/GeneralForm.vue';

export default {
    components: {
        GeneralForm
    },
    data:() => ({
       title : 'Jurnal Rekening Non Air (JRNA)',
       url : '/api/ju',
       routeBack : 'jrnalist',
    }),
    methods: {
       
    }
}
</script>


<style>

</style>